import React from 'react';
import MesonryDescContainer from '../../Componant/Gallery/Mesonry/MesonryDesc';

const MesonryDesc = () => {
  return (
    <div className='page-body'>
      <MesonryDescContainer />
    </div>
  );
};

export default MesonryDesc;
